import React, { useState, useContext } from 'react';
import { NOTAVAILABLE } from '../../constants/global';

// we can put all the imports into export file
import { CHECKBOX, RADIO, DATEPICKER, DROPDOWN, TEXTAREA, TEXTBOX, READONLY, MULTISELECT } from '../../constants/questionType';
import TextInput from '../TextInput/TextInput';
import NumberInput from '../NumberInput/NumberInput';
import Checkbox from '../Checkbox/Checkbox';
import TextArea from '../TextArea/TextArea';
import DatePicker from '../DateInput/DateInput';
import RadioButton from '../RadioButton/RadioButton';
import Dropdown from '../Dropdown/Dropdown';
import MultiSelect from '../MultiSelect/MultiSelect';
import {ToolTip} from '../';
import ReactHtmlParser from 'react-html-parser';

import { success_TextInput, error_TextInput, success_Select, error_Select } from '../ErrorSuccessStates';
import Validator from 'fastest-validator';
import { hasValue, schemaLoader, updateYear } from '../../utils/utils';
import { validationErrorMsg } from '../../constants/validationErrorMsg';
import {Context} from '../../context/dataStore';
// import { Validation } from '../ForceValidate/ForceValidate';
import Icon from './Icon';
import { lockMsg, lockMsgAdmin } from '../../constants/messages';
import { AY } from '../../constants/reminder';
import { disableAndLock } from './util';
import { ADMIN_ROLE, DATE_REGEX } from '../../constants/global';
import { FINISH_ERROR, FINISH_SUCCESS, PROFILE, SAVE_ERROR, SAVE_IN_PROGRESS, SAVE_SUCCESS } from '../../constants/status';

const SmartDisplay = ({ col, moduleAnswers, halfInput, setModuleAnswers, 
                        setModuleErrors, statusOfModule, isLocked, org_rol, org_id, 
                        setModuleStatus,setLastUpdatedAt, setCatStatus, apcp, 
                        curcat, dispatcher = ()=>{}, sampleData = {}}) => {

  const { inputType, inputOptions, questionText, currentValue, validators, cid, mid, qgid, qid, qTag, question_tooltip, lastUpdatedBy } = col;
  const [academicYear, setAcademicYear] = useState('');
  const {postModule, state: {reminderData}} = useContext(Context);

  const required = validators['data_required']===true ? true : '';
  const comId = `${cid}_${mid}_${qgid}_${qid}`;
  const [textInput, setTextInput] = useState(currentValue);
  const [lastText, setLastText] = useState(currentValue);
  const [autosaveChange, setAutosaveChange] = useState(true);
  const AUTOSAVE_INTERVAL = 2000;
  const NAREGEX = /^(N\/A|NA)$/g;

  React.useEffect(()=>{
    if((currentValue===null||currentValue==='')&&validators['data_required']===true){
      if(setModuleErrors){
        setModuleErrors(state =>({...state,[comId]:['required']}));
      }
    }
  }, []);

  React.useEffect(() => {
    const transfer = (val)=>{
      //val is 2022-06-22
      //transfer to be 06/22/2022
      if(inputType === DATEPICKER){
        if(val){
          const [year, month, day] = val.split('-');
          if (year && month && day) {
            return `${month}/${day}/${year}`;
          } else {
            return val;
          }
        }
        else return val;
      }
      if(NAREGEX.test(val?.trim().toUpperCase())) val = NOTAVAILABLE;
      return val;
    };

    const timer = setTimeout(() => {
      if(!apcp){//disable for 'APCP category'
      // if(!apcp && !disableAutosave?.disableAutosave){ delete me later (CDS UPLOAD LOGIC)
        const testval = transfer(textInput);
        if (lastText !== testval) {        
          if(autosaveChange===true){
            if(inputType===DATEPICKER&&!testval){
              //handle datepicker "clear" event
              autoSave('');
            }else{
              autoSave(testval.trim());
            }
            (inputType!==DATEPICKER) ? setLastText(textInput) : setLastText((testval || ''))
          }
        }
      }
    },
    AUTOSAVE_INTERVAL);
    return () => clearTimeout(timer);
  }, [autoSave, cid, inputType, mid, org_id, qgid, qid, textInput]);

  React.useEffect(()=> {
    if(inputType === DATEPICKER && currentValue!==null) {
      // CDS upload has the 'potential' (FIXED) to upload non date values; This prevents autosave from saving the wrong info
      // Test date formatting MM/DD/YYYY
      if (DATE_REGEX.MM_DD_YYYY.test(currentValue) === false){
        // If date formatting is only MM/DD (old data), append the current academic year
        if (DATE_REGEX.MM_DD.test(currentValue)) {
          setTextInput(`${currentValue}/${academicYear}`);
        } else {
          setTextInput('');
        }
      }
    }
  }, [academicYear, currentValue, inputType]);

  React.useEffect(() => reminderData?.forEach(el => {
    if(el.code===AY) {
      setAcademicYear(`${el.value}`);
    }
  }), [reminderData]);

  const fastValidator = new Validator({
    messages: validationErrorMsg
  });

  const displayValidationMsg = (messages, typeSymbol, qId, errorId) => {
    if (typeSymbol.includes('text')) {
      const data = {
        textid1: `${errorId}_one`,
        textid2: `${errorId}_two`,
        textid4: `${errorId}_s`,
        textid5: `${errorId}_e`
      };
      if (messages.length > 0) {
        error_TextInput(data, qId);
        const realm = messages.map(e => `${e}</br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;`);
        let err = realm.join('');
        document.getElementById(data.textid5).innerHTML = err;

        if(messages[0]===validationErrorMsg.required){
          setAutosaveChange(true);
        }
        else{
          setAutosaveChange(false);
        }
        return false;
        
      } else {
        setAutosaveChange(true);
        success_TextInput(data, qId);
      }
    }

    if (typeSymbol.includes('dropdown')||typeSymbol.includes('multi')) {
      const data = {
        textid1: `selectid1-${qId}`,
        textid2: `selectid2-${qId}`,
        textid4: `selectid4-${qId}`,
        textid5: `selectid5-${qId}`
      };
      if (messages.length > 0) {
        error_Select(data, qId);
        const realm = messages.map(e => `${e}</br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;`);
        let err = realm.join('');
        document.getElementById(`selectid5-${qId}`).innerHTML = err;
        if(messages[0]===validationErrorMsg.required){
          setAutosaveChange(true);
        }
        else{
          setAutosaveChange(false);
        }
        return false;
      } else {
        setAutosaveChange(true);
        success_Select(data, qId);
      }
      return true;
    }
    return true;
  };

  const customValidation = (val, qId, errorId, validators, typeSymbol) => {
    if(val===undefined) {
      return null;
    }
    val = val.trim();
    if(NAREGEX.test(val.toUpperCase())){
      return displayValidationMsg('', typeSymbol, qId, errorId);
    }
    
    let displayM = '';
    const schemastr = schemaLoader(validators);
    if (schemastr) {
      const schema = { answer: schemastr };

      let validobj = {};
      if (val !== ''){
        validobj = { answer: val };
      }
      else{
        if(validators['data_type']==='number'){ 
          if(required){
            validobj = {};
          }
          else{
            validobj = {answer:'0'};
          }
          if(inputType === DROPDOWN && required){
            validobj = {};
          }
        }
      }

      let result;
      if (validators.data_type !== 'currency') {
        result = fastValidator.validate(validobj, schema);
      } else {
        //2 steps to validate currency
        //(1) string|pattern
        //(2) convert to number and start min and max
        const firstVschema = { type: schemastr['type'], pattern: schemastr['pattern'], messages: schemastr['messages'], optional: schemastr['optional'] };
        result = fastValidator.validate(validobj, { answer: firstVschema });
        if (result === true) {
          if (val!== '') {
            const secondVschema = { ...schemastr, ['type']: 'number', [`pattern`]: null, ['conver']: true };
            result = fastValidator.validate({ answer: parseFloat(val) }, { answer: secondVschema });
          }
        }
      }

      let fieldErrorArray = [];
      if (result !== true) {
        // for Each is better here too - kb
        displayM = result.map(r => {
          const eType = r.type;
          if (eType === 'required') {
            fieldErrorArray.push(`required`);
          } else {
            fieldErrorArray.push(r.message);
          }
          return r.message;
        });
        if(setModuleErrors){
          setModuleErrors(state=>({ ...state, [qId]: fieldErrorArray }));
        }
      } else {
        if(setModuleErrors){
          setModuleErrors(state=>({ ...state, [qId]: [] }));
        }
      }
    }
    return displayValidationMsg(displayM, typeSymbol, qId, errorId);
  };

  const checkboxAnswer = (textInput, val,qId)=>{
    let newcheckboxanswer = {};

    newcheckboxanswer[qId] = textInput?.split('|');
    if (!newcheckboxanswer[qId]) {
      newcheckboxanswer[qId] = [];
    }
    const ele = val.split(':');
    const qidV = newcheckboxanswer[qId];
    if (ele[1] === 'true') {
      if (!qidV.includes(ele[0])) {
        qidV.push(ele[0]);
      }
    } else {
      for (let i = 0; i < qidV.length; i++) {
        if (qidV[i] === ele[0]) {
          qidV.splice(i, 1);
        }
      }
    }
    return qidV;
  };
  
  const onChangeInputValue = (qId, val, errorId, validators, typeSymbol) => {
    // DELETE ME LATER disableAutosave?.setDisableAutosave(false);
    if (hasValue(validators)) {
      if (customValidation(val, qId, errorId, validators, typeSymbol)) {
        if(typeSymbol.includes('checkbox')){
          const qidV = checkboxAnswer(textInput, val, qId);
          const rtnstr= qidV.join('|');
          if(setModuleAnswers){
            setModuleAnswers(state => ({...state, [qId]: qidV}));
          }
          setTextInput(rtnstr);
        } else if(typeSymbol.includes('datepicker')) {
          const [year, month, day] = val.split('/');
          if (year && month && day && year.length === 4) {
            if(setModuleAnswers)
            setModuleAnswers(state => ({...state, [qId]: `${month}/${day}/${year}`}));
            setTextInput(val);
          }
        }
        else{
          if(setModuleAnswers)
          setModuleAnswers(state =>({...state, [qId]: val.trim()}));
          setTextInput(val);
        }
      } else{
        if(setModuleAnswers)
        setModuleAnswers(state=>({...state, [qId]:''}));
        setTextInput(val);
      }
    } else {
      if (typeSymbol.includes('checkbox')) {
        const qidV = checkboxAnswer(textInput, val, qId);
        const rtnstr= qidV.join('|');
        if(setModuleAnswers)
        setModuleAnswers(state => ({...state, [qId]: qidV}));
        setTextInput(rtnstr);
      } else if(typeSymbol.includes('datepicker')) {
        const arr = val.split('/');
        if(arr.length===3 && arr[0].length===4) {
          if(moduleAnswers)
          moduleAnswers[qId] = `${arr[1]}/${arr[2]}`; //arr[1]}/${arr[2]}/${arr[0]
          setTextInput(val);
        }
      } else {
        if(setModuleAnswers)
        setModuleAnswers(state =>({...state, [qId]: val.trim()}));
        setTextInput(val);
      }
    }

    return val;
  };

  const updateCurrentValue = (pageData, response) => {
  const copy = { ...pageData, modules: pageData.modules.map(module => {
    if(module.id===response.module_id) {
      module.last_updated_at = response.last_updated_at;
    }
    return {...module, question_groups: module.question_groups.map(
        qg => {
            return { ...qg, questions: qg.questions.map(
                question => {
                    if(question.id === response.question_id){
                        question.current_value = response.current_value;
                        question.last_updated_at= response.last_updated_at;
                        question.last_updated_by = response.last_updated_by;
                      }
                      return question;
                }
            )}
        }
    )}
})}

  dispatcher({type: 'SET_MODULE_DATA', payload: copy});
  };

  const autoSave = async (textInput) => {
    dispatcher({ type: 'SET_SAVE_STATUS', payload: SAVE_IN_PROGRESS });
  try {
    const answerarr = [];
    let savedFrom = curcat?.toString().includes(PROFILE)?PROFILE:curcat;
    answerarr.push({ id:qid, category_id:cid, module_id:mid, question_group_id:qgid, current_value: textInput, saved_from: savedFrom});
    const srtn = await postModule(answerarr, org_id);

   if(srtn.data.status==='SUCCESS'){
      dispatcher({ type: 'SET_SAVE_STATUS', payload: SAVE_SUCCESS });
      setModuleStatus(() => 'Modified');
      setLastUpdatedAt(() => (srtn.data.data[0].module_last_updated_at));


      setCatStatus(srtn.data.data[0].category_status, cid);
      updateCurrentValue(sampleData, srtn.data.data[0]);
      setTimeout(() => {
        dispatcher({ type: 'SET_SAVE_STATUS', payload: FINISH_SUCCESS });
      }, 1000);
   }
   else{
      dispatcher({ type: 'SET_SAVE_STATUS', payload: SAVE_ERROR });
      setTimeout(() => {
        dispatcher({ type: 'SET_SAVE_STATUS', payload: FINISH_ERROR });
      }, 1000);
    }

  } catch (e) {
    dispatcher({ type: 'SET_SAVE_STATUS', payload: SAVE_ERROR });
      setTimeout(() => {
        dispatcher({ type: 'SET_SAVE_STATUS', payload: FINISH_ERROR });
      }, 1000);
  }
  };

  const {disableEdit, showQlock} = disableAndLock(apcp, col, org_rol, statusOfModule, qTag, isLocked, curcat);

  if(inputType === DATEPICKER) {
    // some textinput for dates come as null or undefined
    // check for mm/dd/yyyy or yyyy/mm/dd and set format to yyyy-mm-dd
    if(textInput !== null && textInput !== undefined && textInput.includes('/')) {
      if (DATE_REGEX.MM_DD_YYYY.test(textInput)) {
        const [month, day, year] = textInput.split('/');
        setTextInput(`${year}-${month}-${day}`);
      } else {
        const [year, month, day] = textInput.split('/');
        setTextInput(`${year}-${month}-${day}`);
      }
}
    return (
      <div className='col-xs-12 col-sm-12 col-md-12' data-testid={`smartdisplay${comId}`}>
        <DatePicker
          apcp={apcp}
          inputId={`${comId}`}
          halfInput={halfInput}
          requiredInput={required}
          question_tooltip={question_tooltip}
          errorId={`${comId}-Datepickererror`}
          org_rol={org_rol}
          readOnly={disableEdit}
          showQlock={showQlock}
          inputLabel={questionText}
          inputName={questionText}
          textvalue={`${textInput ? textInput : ''}`}
          onChangeInputValue={val => onChangeInputValue(comId, val, `${comId}-Datepickererror`, validators, `datepicker-`)}
        ><Icon iPeds={lastUpdatedBy=='IPEDS'} qTag={qTag} toolTipId={comId}/></DatePicker>
        {/* DELETE ME LATER { forceValidate?.forceValidate &&<Validation  forceValidate={forceValidate} onChangeInputValue={val => onChangeInputValue(comId, updateYear(val), `${comId}-Datepickererror`, validators, `datepicker-`)} textvalue={`${textInput ? textInput : ''}`} questionId={qid} disableAutosave={disableAutosave} currentValue={currentValue} setLastText={setLastText}/>}  */}
      </div>
    );
  }

  if (inputType === TEXTAREA) {
    return (
      <div className='col-xs-12 col-sm-12 col-md-12' data-testid={`smartdisplay${comId}`}>
        <TextArea
          apcp={apcp}
          inputId={`${comId}`}
          halfInput={halfInput}
          org_rol={org_rol}
          errorId={`${comId}-Textareaerror`}
          question_tooltip={question_tooltip}
          textValidAmount={0}
          inputLabel={questionText}
          requiredInput={required}
          inputName={questionText}
          textvalue={`${textInput ? textInput : ''}`}
          maxLength={validators['data_length']}
          readOnly={disableEdit}
          showQlock={showQlock}
          onChangeInputValue={val => onChangeInputValue(comId, val, `${comId}-Textareaerror`, validators, `textarea-`)}
        ><Icon iPeds={lastUpdatedBy=='IPEDS'} qTag={qTag} toolTipId={comId}/></TextArea>
         {/* DELETE ME LATER  { forceValidate?.forceValidate && <Validation forceValidate={forceValidate} onChangeInputValue={val => onChangeInputValue(comId, val, `${comId}-Textareaerror`, validators, `textarea-`)} textvalue={`${textInput ? textInput : ''}`} disableAutosave={disableAutosave} currentValue={currentValue} setLastText={setLastText}/>} */}
      </div>
    );
  }

  if (inputType === TEXTBOX) {
    let type = 'text';

    if (validators['data_type'] === 'number') {
      type = 'number';
      return (
        <div id={`group-${comId}`}  className='col-xs-12 col-sm-12 col-md-12' data-testid={`smartdisplay${comId}`}>
          {
            <NumberInput
              apcp={apcp}
              inputId={`${comId}`}
              halfInput={halfInput}
              org_rol={org_rol}
              inputType={type}
              inputLabel={questionText}
              question_tooltip={question_tooltip}
              requiredInput={required}
              readOnly={disableEdit}
              showQlock = {showQlock}
              inputName={questionText}
              textvalue={`${textInput ? textInput : ''}`}
              errorId={`${comId}-Texterror`}
              minN={validators['data_min']}
              maxN={validators['data_max']}
              onChangeInputValue={val => onChangeInputValue(comId, val, `${comId}-Texterror`, validators, `text-`)}
            ><Icon iPeds={lastUpdatedBy=='IPEDS'} qTag={qTag} toolTipId={comId}/></NumberInput>
          }
          {/* DELETE ME LATER  { (forceValidate?.forceValidate) && <Validation forceValidate={forceValidate} onChangeInputValue={val => onChangeInputValue(comId, val, `${comId}-Texterror`, validators, `text-`)} textvalue={`${textInput ? textInput : ''}`} questionId={qid} disableAutosave={disableAutosave} currentValue={currentValue} setLastText={setLastText}/> } */}
        </div>);
    }
    return (
      <div className='col-xs-12 col-sm-12 col-md-12' data-testid={`smartdisplay${comId}`}>
        
          <TextInput
            apcp={apcp}
            inputId={`${comId}`}
            halfInput={halfInput}
            org_rol={org_rol}
            inputType={type}
            inputLabel={questionText}
            question_tooltip={question_tooltip}
            requiredInput={required}
            readOnly={disableEdit}
            showQlock = {showQlock}
            inputName={questionText}
            textvalue={`${textInput ? textInput : ''}`}
            maxLength={validators['data_length']}
            errorId={`${comId}-Texterror`}
            onChangeInputValue={val => onChangeInputValue(comId, val, `${comId}-Texterror`, validators, `text-`)}
          ><Icon iPeds={lastUpdatedBy=='IPEDS'} qTag={qTag} toolTipId={comId}/></TextInput>
        
       {/* DELETE ME LATER { forceValidate?.forceValidate &&  <Validation forceValidate={forceValidate} onChangeInputValue={val => onChangeInputValue(comId, val, `${comId}-Texterror`, validators, `text-`)} textvalue={`${textInput ? textInput : ''}` } questionId={qid} disableAutosave={disableAutosave} currentValue={currentValue} setLastText={setLastText}/>} */}
      </div>
    );
  }

  if(inputType === MULTISELECT){
    return(
      <div className='col-xs-12 col-sm-12 col-md-12' data-testid={`smartdisplay${comId}`}>
        <MultiSelect selectId={`${comId}`} selectLabel={questionText}
        apcp={apcp}
        halfInput={halfInput}
        readOnly={disableEdit}
        showQlock={showQlock}
        org_rol={org_rol}
        question_tooltip={question_tooltip}
        isRequired={required}
        selectData={inputOptions}
        selectValue={`${textInput ? textInput : ''}`}
        onChangeSelectValue={val => onChangeInputValue(comId, val, `${comId}-MultiselectError`, validators, `multi-`)}
      ><Icon iPeds={lastUpdatedBy=='IPEDS'} qTag={qTag} toolTipId={comId}/></MultiSelect>
      {/* DELETE ME LATER { forceValidate?.forceValidate &&  <Validation forceValidate={forceValidate} onChangeInputValue={val => onChangeInputValue(comId, val, `${comId}-MultiselectError`, validators, `multi-`)} textvalue={`${textInput ? textInput : ''}`} questionId={qid} disableAutosave={disableAutosave} currentValue={currentValue} setLastText={setLastText}/>} */}
      </div>
    );
  }

  if (inputType === DROPDOWN) {
    return (
      <div className='col-xs-12 col-sm-12 col-md-12' data-testid={`smartdisplay${comId}`}>
        <Dropdown selectId={`${comId}`}
          apcp={apcp}
          halfInput={halfInput}
          selectLabel={questionText}
          org_rol={org_rol}
          question_tooltip={question_tooltip}
          readOnly={disableEdit}
          showQlock={showQlock}
          isRequired={required}
          selectData={inputOptions}
          selectValue={`${textInput ? textInput : ''}`} //come from pre-answer
          onChangeSelectValue={val => onChangeInputValue(comId, val, `${comId}-dropdownError`, validators, `dropdown-`)}
        ><Icon iPeds={lastUpdatedBy=='IPEDS'} qTag={qTag} toolTipId={comId}/></Dropdown>
       {/* DELETE ME LATER { forceValidate?.forceValidate &&  <Validation forceValidate={forceValidate} onChangeInputValue={val => onChangeInputValue(comId, val, `${comId}-dropdownError`, validators, `dropdown-`)} textvalue={`${textInput ? textInput : ''}`} questionId={qid} disableAutosave={disableAutosave} currentValue={currentValue} setLastText={setLastText}/>} */}
      </div>
    );
  }

  //radioGroup type
  if (inputType === RADIO) {
    return (
      <div className='col-xs-12 col-sm-12 col-md-12' data-testid={`smartdisplay${comId}`}>
        <fieldset role='radio' aria-labelledby={`${comId}`} aria-required='true' style={{'marginLeft':'12px'}}>
          {/* <div className='display-flex'> */}
            <legend className={`${required===true?'cb-required display-flex':'display-flex'}`} role='presentation' id={`${comId}`}>
              <Icon iPeds={lastUpdatedBy=='IPEDS'} qTag={qTag} customstyle={{padding:'0px 10px 0px 0px'}} toolTipId={comId}/>
              {questionText}</legend>
            {
              question_tooltip?<ToolTip tooltipid={`smartdisplayreadonly${comId}id`} tooltipMsg={question_tooltip} />:''
            }
          {/* </div> */}
          {
            inputOptions.map((elem, index) => (
              <RadioButton
                key={`${comId}-${index}`}
                halfInput={halfInput}
                org_rol={org_rol}
                RadioRequired
                radioId={`${comId}-${index}`}
                readOnly={disableEdit}
                radioInput={`${textInput === elem ? true : ''}`}//should be true or false base on pre anwser
                radioName={questionText}
                radioValue={elem}
                onChangeRadioValue={val => onChangeInputValue(comId, elem, `${comId}-radioError`, validators, `radio-`)}
                >
                {/* DELETE ME LATER { forceValidate?.forceValidate &&  <Validation forceValidate={forceValidate} onChangeInputValue={val => onChangeInputValue(comId, elem, `${comId}-radioError`, validators, `radio-`)} textvalue={`${textInput === elem ? true : ''}`}questionId={qid} disableAutosave={disableAutosave} currentValue={currentValue} setLastText={setLastText}/>} */}
                </RadioButton>
            ))
          }
        </fieldset>
      </div>
    );
  }
  //checkbox or multiselect-dropdown type
  if (inputType === CHECKBOX) {

    //handle single checkbox
    let displayOptions=[];
    let displayQuestionText = '';
    if(!inputOptions||inputOptions?.length===0){
      displayOptions.push(questionText);
    }
    else{
      displayOptions = inputOptions;
      displayQuestionText = questionText;
    }
    return (
      <div className='col-xs-12 col-sm-12 col-md-12' data-testid={`smartdisplay${comId}`}>
        <fieldset style={{'marginLeft':'12px'}}>
          {/* <div className='display-flex'> */}
            <legend className={`${required===true?'cb-required display-flex':'display-flex'}`}>
              <Icon iPeds={lastUpdatedBy=='IPEDS'} qTag={qTag} customstyle={{padding:'0px 10px 0px 0px'}} toolTipId={comId}/>
              {displayQuestionText}
              {required===true? <span className='sr-only' style={{marginRight:'10px'}}> required</span>:<span style={{marginRight:'10px'}}/>}
            
            {
              !apcp&&question_tooltip?<ToolTip tooltipid={`smartdisplayCheckbox${comId}id`} 
                                          tooltipMsg={question_tooltip} 
                                          innerMsg={<span className="cb-icon cb-exclamation-circle"></span>} 
                                          className={'questionToolTip'}
                                          />
                                          :''
              
            }

          </legend>
          {showQlock?
                <ToolTip tooltipid={`checkboxlock${comId}`} 
                tooltipMsg={org_rol===ADMIN_ROLE?lockMsgAdmin:lockMsg} 
                className={'cb-icon cb-lock'} />:''
              }
          {
            displayOptions?.map((elem, index) => (
            <Checkbox
              key={`${comId}-${index}`}
              halfInput={halfInput}
              org_rol={org_rol}
              checkboxId={`${comId}${index}`}
              checkboxInput={Boolean(textInput?(textInput.split('|')).includes(elem):null)}
              checkboxName={elem}
              readOnly={disableEdit}
              checkboxValue={elem}
              onChangecheckboxValue={e => onChangeInputValue(comId, `${elem}:${e.target.checked}`, `${comId}-checkboxError`, validators, `checkbox-`)}
            >
            {/* DELETE ME LATER { forceValidate?.forceValidate &&   <Validation forceValidate={forceValidate} onChangeInputValue={e => onChangeInputValue(comId, `${elem}:${e.target.checked}`, `${comId}-checkboxError`, validators, `checkbox-`)} textvalue={Boolean(textInput?(textInput.split('|')).includes(elem):null)} questionId={qid} disableAutosave={disableAutosave} />} */}
            </Checkbox>
            )
            )}
        </fieldset>
      </div>
    );
  }

  if (inputType === READONLY) {
    return (
      <div className='col-xs-12 col-sm-12 col-md-12 display-flex' style={{'marginLeft':'12px'}} data-testid={`smartdisplay${comId}`}>
          <p className='readonlyQ' role="heading" aria-level="4">{ReactHtmlParser(questionText)}</p>
          {
            question_tooltip?<ToolTip tooltipid={`smartdisplayreadonly${comId}id`} tooltipMsg={question_tooltip} />:''
          }
      </div>);
  }

  return (<>default '{inputType}' could not be recognized</>);
};

export default SmartDisplay;